import { render, staticRenderFns } from "./OrganizationTeams.vue?vue&type=template&id=3aab0964&"
import script from "./OrganizationTeams.vue?vue&type=script&lang=js&"
export * from "./OrganizationTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports